import React from "react";
import Projects from "./Projects";

export default function ProjectsSection() {
  return (
    <section id="projects" className="projects">
        <Projects />
    </section>
  );
}
